import cn from "classnames";
import LinkifyIt from "linkify-it";
import { useMemo, useState } from "react";
import Linkify from "react-linkify";

type LinkifyTextProps = {
  text?: string;
  placeholder?: string;
  className?: string;
  linkClassName?: string;
  wrap?: boolean;
};

export const LinkifyText: React.FC<LinkifyTextProps> = ({
  text,
  placeholder,
  wrap = true,
  className,
  linkClassName,
}) => {
  const [linkify] = useState(new LinkifyIt());

  const content = useMemo(() => {
    return !text ? (
      <span className="color-secondary">{placeholder}</span>
    ) : (
      <Linkify
        matchDecorator={(matchDecoratorText) =>
          linkify.match(matchDecoratorText)
        }
        // eslint-disable-next-line react/no-unstable-nested-components
        componentDecorator={(href, componentText, key) => (
          <a
            key={key}
            href={href}
            target="_blank"
            className={linkClassName}
            rel="noreferrer"
          >
            {componentText}
          </a>
        )}
      >
        {text}
      </Linkify>
    );
  }, [text, placeholder, linkify, linkClassName]);

  if (wrap === true)
    return <div className={cn("pre-wrap", className)}>{content}</div>;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{content}</>;
};
